import OutsideEventsMixin from 'vuemixins/outside_events_mixin'
import { $ } from 'bits/jquery'

export default {
  mixins: [OutsideEventsMixin],
  mounted() {
    let eventName = !!document.documentElement.ontouchstart ? 'touchstart.modal' : 'click.modal'
    let _this = this
    $(this.$el).on(eventName, function(e) {
      if (this === e.target) {
        _this.cancel(e)
      }
    })
  },
  beforeDestroy() {
    $(this.$el).off('.modal')
  },
  methods: {
    onEscape(e) {
      this.cancel(e)
    },
  },
}
